import { Page } from "@/models/page-models/Page";

export const OperatorView: Page = {
  "path": "operator-view",
  "name": "Operator View",
  "props": {
    "data": {
      "title": "Operator View",
      "printable": "FALSE",
      "url": "operator-view",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.factoryTicket",
                  "label": "{{translated('select_factory_ticket')}}",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetFormData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.process"
                      },
                      "name": "resetFormData"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetProcessName",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.machine"
                      },
                      "name": "resetProcessName"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyOrderId",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject.order._id",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.order"
                      },
                      "name": "copyOrderId"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copySelectedOrder",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject.order",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedOrder"
                      },
                      "name": "copySelectedOrder"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "getOrderProcesses",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/factoryticket/orderprocess?id={{formData.order}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.orderProcesses",
                        "arg3Key": "addToState",
                        "arg3Value": "{\"actionName\":\"addMultipleGoods\",\"variable\":\"fetchedData.orderProcesses.data.goods\"}"
                      },
                      "name": "getOrderProcesses"
                    },
                    {
                      "executionOrder": 4,
                      "pageFunction": {
                        "name": "convertProcesses",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.orderProcesses.data",
                        "arg2Key": "sourceFn",
                        "arg2Value": "getConvertedProcesses",
                        "arg3Key": "destinationKey",
                        "arg3Value": "fetchedData",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object",
                        "arg5Key": "append",
                        "arg5Value": "TRUE"
                      },
                      "name": "convertProcesses"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "copyProductForm",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getProductForm",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.productForm"
                      },
                      "name": "copyProductForm"
                    },
                    {
                      "executionOrder": 4,
                      "pageFunction": {
                        "name": "getProductData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/detail",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.selectedProduct",
                        "arg3Key": "sourceTransformationFn",
                        "arg3Value": "transformProductData",
                        "arg4Key": "postData",
                        "arg4Value": "fetchedData.productForm"
                      },
                      "name": "getProductData"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getFactoryTicketData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/factoryticket/get?id={{formData.factoryTicket}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.selectedFactoryTicket",
                        "arg3Key": "sourceTransformationFn",
                        "arg3Value": "transformFactoryTicketData"
                      },
                      "name": "getFactoryTicketData"
                    },
                    {
                      "executionOrder": 5,
                      "pageFunction": {
                        "name": "copyDropdownStatus",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDropdownStatus",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copyDropdownStatus"
                    },
                    {
                      "executionOrder": 5,
                      "name": "copyPrintedStatus"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,{{fetchedData.dropdownStatus}},==,false)",
                  "items": "fetchedData.factoryTickets.data",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,factoryTicketDescription,{{__item}})",
                  "validationKey": "order"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Order Details",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "custom_FtOrderDetails",
                      "variable": "fetchedData.selectedOrder",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selectedOrder}}"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Product Details",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "label",
                      "label": "Product Details",
                      "class": "text-h5"
                    }
                  ]
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "label",
                      "variable": "fetchedData.selectedProduct.customer.name",
                      "label": "Customer",
                      "labelType": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{fetchedData.selectedOrder.customer}})"
                    },
                    {
                      "type": "label",
                      "label": "Status",
                      "labelType": "formula",
                      "formula": "fn(CONCAT,{{fetchedData.selectedProduct.product.status}}, (,<span class=\"green--text\">,{{fetchedData.selectedProduct.product.repeatType}},</span>,))"
                    }
                  ]
                },
                {
                  "name": "3",
                  "pageItems": [
                    {
                      "type": "label",
                      "variable": "fetchedData.selectedProduct.product._id",
                      "label": "Product ID"
                    },
                    {
                      "type": "label",
                      "variable": "fetchedData.selectedProduct.product",
                      "label": "Product",
                      "formula": "fn(HELPER_FN,productAlias,{{fetchedData.selectedProduct.product}})"
                    }
                  ]
                },
                {
                  "name": "4",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.selectedProduct.product.productLine",
                      "label": "Product Line",
                      "onVarUpdate": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copySelectedProductLine",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__selectedObject",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.selected",
                            "arg3Key": "destinationKeyType",
                            "arg3Value": "Object"
                          },
                          "name": "copySelectedProductLine"
                        }
                      ],
                      "disabled": "FALSE",
                      "items": "fetchedData.productLines.data.0.data",
                      "itemText": "name",
                      "itemValue": "name"
                    }
                  ],
                  "disabled": "TRUE"
                },
                {
                  "name": "5",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.selectedProduct.product.form",
                      "label": "Form",
                      "onVarUpdate": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copySelectedShapeData",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__selectedObject",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.selected.data",
                            "arg3Key": "destinationKeyType",
                            "arg3Value": "Object",
                            "arg4Key": "append",
                            "arg4Value": "TRUE"
                          },
                          "name": "copySelectedShapeData"
                        }
                      ],
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.form}}",
                      "items": "fetchedData.selected.data.form",
                      "itemText": "title",
                      "itemValue": "title"
                    }
                  ]
                },
                {
                  "name": "6",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.selectedProduct.product.shape",
                      "label": "Shape",
                      "onVarUpdate": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copySelectedShapeData",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__selectedObject",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.selected.data",
                            "arg3Key": "destinationKeyType",
                            "arg3Value": "Object",
                            "arg4Key": "append",
                            "arg4Value": "TRUE"
                          },
                          "name": "copySelectedShapeData"
                        }
                      ],
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.shapes}}",
                      "items": "fetchedData.selected.data.shapes",
                      "itemText": "title",
                      "itemValue": "title"
                    }
                  ]
                },
                {
                  "name": "7",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.customerItemId",
                      "label": "Customer Item Code",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selectedProduct.product.productLine}}"
                    }
                  ]
                },
                {
                  "name": "8",
                  "pageItems": [
                    {
                      "type": "dynamicGroup",
                      "variable": "fetchedData.selectedProduct.product.size",
                      "label": "Size",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.attributes.size}}",
                      "items": "fetchedData.selected.data.attributes.size",
                      "config": {
                        "type": "input",
                        "unit": "__item.unit",
                        "label": "__item.value",
                        "variable": "__item.value"
                      }
                    },
                    {
                      "type": "label",
                      "label": "Total Diameter",
                      "unit": "mm",
                      "showIf": "{{fetchedData.selectedProduct.product.size.BDIA}}",
                      "labelType": "formula",
                      "formula": "fn(SUM,{{fetchedData.selectedProduct.product.size.BDIA}},fn(MULTIPLY,{{fetchedData.selectedProduct.product.size.HEIGHT}},2))"
                    }
                  ]
                },
                {
                  "name": "9",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.selectedProduct.product.structure",
                      "label": "Structure",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.attributes.structure}}",
                      "items": "fetchedData.selected.data.attributes.structure"
                    }
                  ]
                },
                {
                  "name": "10",
                  "pageItems": [
                    {
                      "type": "dynamicGroup",
                      "variable": "fetchedData.selectedProduct.product.baseMaterial",
                      "label": "Base Material",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.attributes.baseMaterial}}",
                      "items": "fetchedData.selected.data.attributes.baseMaterial",
                      "config": {
                        "type": "input",
                        "unit": "__item.unit",
                        "label": "__item.value",
                        "variable": "__item.value"
                      }
                    }
                  ]
                },
                {
                  "name": "11",
                  "pageItems": [
                    {
                      "type": "dynamicGroup",
                      "variable": "fetchedData.selectedProduct.product.topMaterial",
                      "label": "Top Material",
                      "disabled": "FALSE",
                      "showIf": "fn(LOGICAL,'{{fetchedData.selectedProduct.product.structure}}',==,'Multi')",
                      "items": "fetchedData.selected.data.attributes.topMaterial",
                      "config": {
                        "type": "input",
                        "unit": "__item.unit",
                        "label": "__item.value",
                        "variable": "__item.value"
                      }
                    }
                  ]
                },
                {
                  "name": "12",
                  "pageItems": [
                    {
                      "type": "dynamicGroup",
                      "variable": "fetchedData.selectedProduct.product.tray.trayMaterial",
                      "label": "Tray Material",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.attributes.trayMaterial}}",
                      "items": "fetchedData.selected.data.attributes.trayMaterial",
                      "config": {
                        "type": "input",
                        "unit": "__item.unit",
                        "label": "__item.value",
                        "variable": "__item.value"
                      }
                    }
                  ]
                },
                {
                  "name": "13",
                  "pageItems": [
                    {
                      "type": "dynamicGroup",
                      "variable": "fetchedData.selectedProduct.product.tray.cupMaterial",
                      "label": "Cup Material",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.attributes.cupMaterial}}",
                      "items": "fetchedData.selected.data.attributes.cupMaterial",
                      "config": {
                        "type": "input",
                        "unit": "__item.unit",
                        "label": "__item.value",
                        "variable": "__item.value"
                      }
                    }
                  ]
                },
                {
                  "name": "14",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.selectedProduct.product.printing.printType",
                      "label": "Print Type",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.attributes.showPrinting}}",
                      "items": "[\"Plain\",\"Printed\"]",
                      "dropdownType": "static"
                    },
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.selectedProduct.product.printing.windingDirection",
                      "label": "Winding Direction",
                      "disabled": "FALSE",
                      "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedProduct.product.printing.printType}},'),==,'Printed')",
                      "items": "[\"C1\",\"C2\",\"C3\",\"C4\",\"C5\",\"C6\",\"C7\",\"C8\",\"Manual\"]",
                      "dropdownType": "static"
                    }
                  ]
                },
                {
                  "name": "15",
                  "pageItems": [
                    {
                      "type": "arrayGroup",
                      "variable": "fetchedData.selectedProduct.product.printing.design",
                      "label": "Design Files",
                      "disabled": "TRUE",
                      "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedProduct.product.printing.printType}},'),==,'Printed')",
                      "arrayItems": [
                        {
                          "name": "1",
                          "pageItems": [
                            {
                              "type": "input",
                              "variable": "designName",
                              "label": "Design Name",
                              "disabled": "FALSE"
                            },
                            {
                              "type": "fileupload",
                              "variable": "designFile",
                              "label": "Design File",
                              "disabled": "FALSE",
                              "color": "primary",
                              "previewType": "no-preview"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "16",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.wetWipes.shape",
                      "label": "Sachet Shape",
                      "disabled": "FALSE"
                    },
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.wetWipes.sachetGsm",
                      "label": "Sachet GSM",
                      "unit": "GSM",
                      "disabled": "FALSE"
                    }
                  ],
                  "showIf": "fn(LOGICAL,'{{fetchedData.selectedProduct.product.productLine}}',==,'Wet Wipes')"
                },
                {
                  "name": "17",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.wetWipes.fragrance",
                      "label": "Fragrance",
                      "disabled": "FALSE"
                    },
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.wetWipes.sachetStructure",
                      "label": "Sachet Structure",
                      "disabled": "FALSE"
                    }
                  ],
                  "showIf": "fn(LOGICAL,'{{fetchedData.selectedProduct.product.productLine}}',==,'Wet Wipes')"
                },
                {
                  "name": "18",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.wetWipes.tissueLength",
                      "label": "Tissue Length",
                      "unit": "mm",
                      "disabled": "FALSE"
                    },
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.wetWipes.tissueWidth",
                      "label": "Tissue Width",
                      "unit": "mm",
                      "disabled": "FALSE"
                    },
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.wetWipes.tissueGsm",
                      "label": "Tissue GSM",
                      "unit": "GSM",
                      "disabled": "FALSE"
                    },
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.wetWipes.tissueType",
                      "label": "Tissue Type",
                      "disabled": "FALSE"
                    }
                  ],
                  "showIf": "fn(LOGICAL,'{{fetchedData.selectedProduct.product.productLine}}',==,'Wet Wipes')"
                },
                {
                  "name": "19",
                  "pageItems": [
                    {
                      "type": "custom_PackingMode",
                      "variable": "fetchedData.selectedProduct.product.packingMode",
                      "label": "Packing Mode",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selectedProduct.product.productLine}}",
                      "config": {
                        "productLine": "fetchedData.selected",
                        "sellingUnit": "fetchedData.selectedProduct.product.unit.unit2"
                      }
                    }
                  ]
                },
                {
                  "name": "20",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "fetchedData.selectedProduct.product.minimumQuantity",
                      "label": "Minimum Order Quantity",
                      "unit": "{{fetchedData.selectedProduct.product.unit.unit2}}",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selected.data.attributes.size}}"
                    },
                    {
                      "type": "checkbox",
                      "variable": "fetchedData.selectedProduct.product.hasFOC",
                      "label": "Has FOC",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selectedProduct.product.productLine}}"
                    }
                  ]
                }
              ],
              "disabled": "TRUE"
            },
            {
              "tabName": "Artwork Details",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "fileupload",
                      "variable": "fetchedData.selectedProduct.product.printing.design.0.designFile",
                      "label": "Design File",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.selectedProduct.product.printing.design.0.designFile}}",
                      "color": "primary",
                      "previewType": "full-size"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Factory Ticket",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "custom_FtProcesses",
                      "variable": "fetchedData.selectedFactoryTicket.factoryTicket.processes",
                      "label": "Processes",
                      "disabled": "TRUE",
                      "showIf": "{{fetchedData.selectedFactoryTicket.factoryTicket.order}}",
                      "items": "formData.processes",
                      "config": {
                        "orderDetailsVariable": "fetchedData.selectedFactoryTicket.selectedOrderDetails",
                        "formVariable": "fetchedData.selectedFactoryTicket.factoryTicket",
                        "fixedWidth": true
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Production Report",
              "rows": [
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.machine",
                      "label": "{{translated('select_process')}}",
                      "onVarUpdate": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copySelectedProcess",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__selectedObject",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.process"
                          },
                          "name": "copySelectedProcess"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copyDefaultFormValues",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultFormValues",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultFormValues"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copyMachineName",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "formData.process.machineDetail._id",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.productionMachine"
                          },
                          "name": "copyMachineName"
                        }
                      ],
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "items": "fetchedData.processes",
                      "itemText": "machine",
                      "itemValue": "_key",
                      "formula": "fn(HELPER_FN,productionProcess,{{__item}})",
                      "validationKey": "process"
                    }
                  ]
                },
                {
                  "name": "4",
                  "pageItems": [
                    {
                      "type": "label",
                      "label": "{{translated('production_entry_details')}}",
                      "showIf": "{{formData.order}}"
                    }
                  ]
                },
                {
                  "name": "5",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.productionMachine",
                      "label": "{{translated('search_machine')}}",
                      "onVarUpdate": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copySelectedMachineData",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__selectedObject",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.machine"
                          },
                          "name": "copySelectedMachineData"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copyDefaultMachineSpeeds",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultMachineSpeeds",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultMachineSpeeds"
                        }
                      ],
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "items": "fetchedData.machines.data",
                      "itemText": "name",
                      "itemValue": "_id",
                      "validationKey": "machine"
                    },
                    {
                      "type": "input",
                      "variable": "formData.numberOfMen",
                      "label": "{{translated('number_of_men')}}",
                      "unit": "men",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "numberOfMen"
                    }
                  ]
                },
                {
                  "name": "6",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "formData.standardSpeed",
                      "label": "{{translated('standard_speed')}}",
                      "unit": "m/min",
                      "disabled": "TRUE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "standardSpeed"
                    },
                    {
                      "type": "input",
                      "variable": "formData.activeSpeed",
                      "label": "{{translated('active_speed')}}",
                      "unit": "m/min",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "activeSpeed"
                    }
                  ]
                },
                {
                  "name": "7",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "formData.setupDT",
                      "label": "{{translated('setup_dt')}}",
                      "unit": "min",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "setupDT"
                    },
                    {
                      "type": "input",
                      "variable": "formData.maintenanceDT",
                      "label": "{{translated('maintenance_dt')}}",
                      "unit": "min",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "maintenanceDT"
                    },
                    {
                      "type": "input",
                      "variable": "formData.productionDT",
                      "label": "{{translated('production_dt')}}",
                      "unit": "min",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "productionDT"
                    }
                  ]
                },
                {
                  "name": "8",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "formData.hourMeterStart",
                      "label": "{{translated('hour_meter_start')}}",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "hourMeterStart"
                    },
                    {
                      "type": "input",
                      "variable": "formData.hourMeterEnd",
                      "label": "{{translated('hour_meter_end')}}",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "hourMeterEnd"
                    }
                  ]
                },
                {
                  "name": "9",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "formData.setupWaste",
                      "label": "{{translated('setup_waste')}}",
                      "unit": "kg",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "setupWaste"
                    },
                    {
                      "type": "input",
                      "variable": "formData.maintenanceWaste",
                      "label": "{{translated('maintenance_waste')}}",
                      "unit": "kg",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "maintenanceWaste"
                    }
                  ]
                },
                {
                  "name": "10",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "formData.trimWaste",
                      "label": "{{translated('trim_waste')}}",
                      "unit": "kg",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "trimWaste"
                    },
                    {
                      "type": "input",
                      "variable": "formData.productionWaste",
                      "label": "{{translated('production_waste')}}",
                      "unit": "kg",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "productionWaste"
                    }
                  ]
                },
                {
                  "name": "11",
                  "pageItems": [
                    {
                      "type": "datepicker",
                      "variable": "formData.productionDate",
                      "label": "{{translated('production_date')}}",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}",
                      "validationKey": "productionDate"
                    },
                    {
                      "type": "timePicker",
                      "variable": "formData.timeFrom",
                      "label": "{{translated('time_from')}}",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}"
                    },
                    {
                      "type": "timePicker",
                      "variable": "formData.timeTo",
                      "label": "{{translated('time_to')}}",
                      "disabled": "FALSE",
                      "showIf": "{{formData.order}}"
                    },
                    {
                      "type": "label",
                      "variable": "formData.timeSpent",
                      "label": "{{translated('total_hours')}}",
                      "showIf": "{{formData.order}}",
                      "labelType": "formula",
                      "formula": "fn(TIME_DIFF,{{formData.timeFrom}},{{formData.timeTo}})",
                      "storeFormulaValue": true
                    }
                  ]
                },
                {
                  "name": "12",
                  "pageItems": [
                    {
                      "type": "custom_ProductionReport",
                      "variable": "formData.process",
                      "label": "Production Report",
                      "disabled": "FALSE",
                      "showIf": "{{formData.process}}",
                      "config": {
                        "goodsVariable": "fetchedData.orderProcesses.data.goods",
                        "processesVariable": "fetchedData.orderProcesses.data.processes",
                        "resetData": true,
                        "wipVariable": "fetchedData.factoryWip.data",
                        "orderVariable": "fetchedData.selectedOrder"
                      }
                    }
                  ]
                },
                {
                  "name": "13",
                  "pageItems": [
                    {
                      "type": "button",
                      "label": "Save",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "saveProductionReport",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/productionreport",
                            "arg2Key": "postData",
                            "arg2Value": "formData",
                            "arg3Key": "refreshPage",
                            "arg3Value": "TRUE"
                          },
                          "name": "saveProductionReport"
                        }
                      ],
                      "disabled": "FALSE",
                      "showIf": "{{formData.process}}",
                      "color": "primary"
                    }
                  ]
                }
              ]
            }
          ],
          "showIf": "{{formData.factoryTicket}}",
          "showVertical": true
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getFactoryTickets",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/factory-ticket/to-produce",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.factoryTickets"
        },
        "name": "getFactoryTickets"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMachines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/machines/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.machines"
        },
        "name": "getMachines"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getProductLines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=product-lines1",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productLines"
        },
        "name": "getProductLines"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDropdownStatus",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDropdownStatus",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDropdownStatus"
      }
    ],
    "functions": [
      {
        "name": "getConvertedProcesses",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "processes": "fn(TO_ARRAY,{{__selectedObject.processes}})"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultFormValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "productionDate": "fn(HELPER_FN,dateFormat,{{TODAYS_DATE}},date-picker)",
          "setupDT": "0",
          "maintenanceDT": "0",
          "productionDT": "0",
          "setupWaste": "0",
          "maintenanceWaste": "0",
          "trimWaste": "0",
          "productionWaste": "0"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultMachineSpeeds",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "standardSpeed": "{{formData.machine.mechanicalSpeed}}",
          "activeSpeed": "{{formData.machine.mechanicalSpeed}}"
        },
        "useFormula": true
      },
      {
        "name": "transformProductData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "__selectedObject.data"
        }
      },
      {
        "name": "transformFactoryTicketData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "factoryTicket": "__selectedObject.data.0",
          "selectedOrderNo": "__selectedObject.data.0.order._id",
          "selectedOrderDetails": "__selectedObject.data.0.order"
        }
      },
      {
        "name": "copyPrintedStatus",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getPrintedStatus",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedProduct.product.printing",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getPrintedStatus",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "printType": "fn(CONDITIONAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.selectedProduct.product.printing.design}}),>,0),Printed,Plain)"
        },
        "useFormula": true
      },
      {
        "name": "getDropdownStatus",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "dropdownStatus": "fn(LOGICAL,{{formData.factoryTicket}},>,0)"
        },
        "useFormula": true
      },
      {
        "name": "getProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "fetchedData.selectedOrder.product._id"
        }
      }
    ]
  },
  "forRole": "PRODUCTION_OPERATOR",
  "visible": true,
  "routerPriority": 100
}